import firebase from 'firebase/app';
import { app } from '../../../index';
import { store } from '../../../../store';
import { getTableByNumber } from '../../tables/get';

export const addOrder = async (order) => {
  try {
    const db = app.firestore();
    const { establishment: { id } } = store.getState();

    const orderData = {
      ...order,
      establishmentId: id,
      serverTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
    };

    const newOrder = db.collection('orders').doc();
    const batch = db.batch();
    batch.set(newOrder, orderData);

    if (order.origin === 'table') {
      const table = await getTableByNumber(Number(order.userTable));
      if (!table?.id) return false;
      batch.update(db.collection('tables').doc(table.id), {
        activeOrders: firebase.firestore.FieldValue.arrayUnion(newOrder.id),
        updatedAt: Date.now(),
      });
    }

    await batch.commit();

    if (newOrder.id) {
      return {
        ...orderData,
        id: newOrder.id,
      };
    }

    return false;
  } catch (err) {
    console.log('err');
    console.log(err);
    return false;
  }
};
